<template>
  <g class="status-durations" transform="translate(1515, 40)">
    <text class="status-duration" transform="translate(0, 30)" dy="0.35em">{{
        (new Date(off
        .map((x) => x.dur)
        .reduce((acc, item) => {
          return (acc += item);
        }, 0) * 1000)).toUTCString().match(/(\d\d:\d\d)/)[0]
    }}</text>
    <text class="status-duration" transform="translate(0, 70)" dy="0.35em"
      >
      {{
        (new Date(sb
        .map((x) => x.dur)
        .reduce((acc, item) => {
          return (acc += item);
        }, 0) * 1000)).toUTCString().match(/(\d\d:\d\d)/)[0]
    }}</text
    >
    <text class="status-duration" transform="translate(0, 110)" dy="0.35em"
      >{{
        (new Date(dr
        .map((x) => x.dur)
        .reduce((acc, item) => {
          return (acc += item);
        }, 0) * 1000)).toUTCString().match(/(\d\d:\d\d)/)[0]
    }}</text
    >
    <text class="status-duration" transform="translate(0, 150)" dy="0.35em"
      >{{
        (new Date(on
        .map((x) => x.dur)
        .reduce((acc, item) => {
          return (acc += item);
        }, 0) * 1000)).toUTCString().match(/(\d\d:\d\d)/)[0]
    }}</text
    >
  </g>
</template>
<script>
export default {
  props: ["on", "off", "sb", "dr"],
};
</script>